<template>
  <Breadcrumbs title="" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header" style="border-bottom-left-radius: 15px;border-bottom-right-radius: 15px;" v-if="this.eventDetails.title">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img style="width: 100%;box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);border-radius: 0.6em;border: none;padding: 0;background: transparent;"
                  :src="this.eventDetails.coverurl"
                  alt="Image description"
                />
              </figure>
            </div>
            <h5>{{ this.eventDetails.title }}</h5>
           
                <p style="font-size: small; line-height: 1.2;">
                  <i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ this.eventDetails.event_date_text }}<br />
                  &nbsp;<i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp; {{ this.eventDetails.province }}<br />
                  {{ this.currentLanguage === 'en' ? "Open search at" : "ช่วงเวลาที่เปิดขาย" }}: {{ this.eventDetails.on_sale_start }}
                  <span>
                    &nbsp;{{ this.currentLanguage === 'en' ? "To" : "ถึงวันที่" }}: {{ this.eventDetails.on_sale_end }}
                    <template v-if="this.eventDetails.day_diff <= 10 && this.eventDetails.day_diff > 0">
                      <font style="color: red">
                        ({{ this.currentLanguage === 'en' ? "There is still time left to store photo" : "คงเหลือเวลาจัดเก็บรูปอีก" }} {{ this.eventDetails.day_diff }} {{ this.currentLanguage === 'en' ? "days" : "วัน" }})
                      </font>
                    </template>
                  </span>
                </p>


            <p>
              <span
                style="padding: 5px; margin: 3px;"
                v-for="(_package, index) in this.eventDetails.package.filter(pkg => pkg.number_of_photo !== 0)"
                :key="index"
                class="btn btn-outline-info"
              >
                <b>{{ this.currentLanguage === 'en' ? _package.name_en : _package.name }}</b>
              </span>
            </p>

          
           <!-- stage event -->
           <a :href="'../'+this.$route.params.event_id">
            <button v-if="this.eventDetails.is_event_stage	 === 'Y'" class="btn btn-lg btn-primary" style="width: 100%" >{{this.currentLanguage ==='en'?"Find images by Facesearch for get unlimited packages":"ค้นหารูปด้วยใบหน้า เพื่อซื้อโปรเหมาๆ"}}</button></a>
            <!-- end stage event -->
            <p style="font-size: small;" v-if="this.eventDetails.is_event_stage === 'Y'">
              <template v-if="this.currentLanguage === 'en'">
              <b>Recommendation: Find more photos (no additional cost)</b><br>
              &nbsp; For searching additional photos, such as underwater photos or photos without visible faces, after you have purchased the unlimited package:<br>
              &nbsp; <b>1. Initial search:</b> Upload your face photo to the system to search for images, select the unlimited package, fill in all information, and complete the payment.<br>
              &nbsp; <b>2. Search for more photos:</b> Click the "Manual find images" button, select the event location, and add the desired photos to your cart. Then create an order for "Request additional photos after unlimited purchase".<br>
              &nbsp; <b>3. Notify admin:</b> Notify the admin for approval. Once approved, you can download the additional photos immediately.
              </template>
              <template v-else>
              <b>คำแนะนำ: ค้นหารูปภาพเพิ่มเติม (ไม่เสียค่าใช้จ่าย)</b><br>  
              &nbsp; สำหรับการค้นหารูปภาพเพิ่มเติม เช่น ภาพใต้น้ำ หรือภาพที่ไม่เห็นใบหน้า หลังจากที่คุณได้สั่งซื้อแพ็กเกจเหมาๆ รูปภาพไปแล้ว:<br>
              &nbsp; <b>1. ค้นหาภาพเริ่มต้น:</b> อัปโหลดรูปใบหน้าของคุณเข้าระบบเพื่อค้นหาภาพ และเลือกโปรเหมาๆ กรอกข้อมูลให้ครบถ้วนและชำระเงินเรียบร้อย<br>
              &nbsp; <b>2. ค้นหาภาพเพิ่มเติม:</b> กดปุ่ม "ค้นหารูปภาพด้วยตนเอง" เลือกสถานที่แข่งขัน และเพิ่มรูปภาพที่คุณต้องการลงในตะกร้า จากนั้นสร้างคำสั่งซื้อ "ขอรูปเพิ่มเติมหลังจากเหมาไปแล้ว"<br>
              &nbsp; <b>3. แจ้งแอดมิน:</b> แจ้งแอดมินเพื่อขออนุมัติ เมื่อได้รับการอนุมัติแล้ว คุณสามารถดาวน์โหลดรูปภาพเพิ่มเติมได้ทันที
              </template>
            </p>
          </div>

          <!-- manual event -->
           <a :href="'../'+this.$route.params.event_id">
            <button v-if="this.eventDetails.is_event_manual	 === 'Y'" class="btn btn-lg d-flex align-items-center justify-content-center gap-2" style="width: 100%; background: linear-gradient(135deg, #6c757d, #495057); border: none; border-radius: 10px; font-weight: 600; color: white; box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3); transition: all 0.3s ease;" 
                   onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 20px rgba(108, 117, 125, 0.4)'; this.style.background='linear-gradient(135deg, #5a6268, #343a40)'" 
                   onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 4px 15px rgba(108, 117, 125, 0.3)'; this.style.background='linear-gradient(135deg, #6c757d, #495057)'">
              <vue-feather type="search" size="20"></vue-feather>
              {{this.currentLanguage ==='en'?"Back to Search by face":"ย้อนกลับ เพื่อค้นหาด้วยใบหน้า"}}
            </button></a>
            <ManualSearchNote 
              v-if="this.eventDetails.is_event_manual === 'Y'" 
              :currentLanguage="this.currentLanguage" 
            />
            <!-- manual event -->

          <div class="row" style="padding-left: 20px;padding-right: 20px;" >
            <div class="col-sm-12" v-if="this.eventDetails.can_sale === 'N'">
                <p>&nbsp;</p>
                <div class="d-flex justify-content-center">
                  
                  <b>
                    {{this.currentLanguage ==='en'?"Please come back to search at":"เปิดให้ค้นหา"}} {{ this.eventDetails.on_sale_start_txt }}
                  </b>
                </div>
                <hr style="padding-left: 20px;">
                <div class="d-flex justify-content-center">
                   {{this.currentLanguage ==='en'?"Alternatively, you can follow us at":"หรือสามารถมารถติดตามพวกเราได้ที่"}}
                </div>
                <div class="d-flex justify-content-center">
                  <a :href="fbUrl" target="_blank"><h5><img style="align-items: center; height: 40px" src="../../assets/images/running/facebook-icon.png" />  {{fbName}}</h5></a>
                </div>
              </div>
              <p>&nbsp;</p>
          </div>
        </div>
        
        <!-- image stage -->

        <p>&nbsp; </p>
        <div class="card" v-if="this.eventDetails.is_event_stage	 === 'Y' && this.eventDetails.can_sale === 'Y'">     
          <div >
            <p >&nbsp;</p>
            <div class="row">
              <div class="col-sm-1 col-lg-1 col-xl-1">
              </div>
              <div class="col-sm-10 col-lg-10 col-xl-10">
                <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="event_stages"
                            aria-label="Floating label select example">
                            <option v-for="(item, index) in this.eventDetails.stage" :key="index"
                              :value="item.id"> # {{this.currentLanguage ==='en'?item.name_en:item.name}}</option>
                      </select>
                      <label for="floatingSelect">Find by Location / Stages / Session / Type</label>
                      </div>
                  </div>
                  <div class="col-sm-1 col-lg-1 col-xl-1">
                  </div>
            </div>
              <!-- <div class="row">
                <div class="col-sm-1 col-lg-1 col-xl-1">
                </div>
              <div class="col-sm-10 col-lg-10 col-xl-10">
                <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="image_time" 
                            aria-label="Floating label select example">
                            <option v-for="(item, index) in this.image_times" :key="index"
                              :value="item.timeDurationKey"> {{item.timeDuration}}</option>
                      </select>
                      <label for="floatingSelect">Find by duration time</label>
                      </div>
              </div>
              <div class="col-sm-1 col-lg-1 col-xl-1">
              </div>
              </div> -->
              
              <div class="row">
                <div class="col-sm-1 col-lg-1 col-xl-1">
                </div>
              <div class="col-sm-10 col-lg-10 col-xl-10">
                <div class="d-flex justify-content-center">
                  <button type="button" @click.prevent="find_image" style="cursor: pointer" class="btn btn-primary btn-lg" >
                   <vue-feather type="search" size="16" ></vue-feather>{{this.currentLanguage ==='en'?"Search":"ค้นหา"}}</button>
                   &nbsp;
                  <button style="cursor: pointer" type="reset" @click.prevent="find_image_clear" class="btn btn-secondary btn-lg" >{{this.currentLanguage ==='en'?"Cancel":"ยกเลิก"}}</button>
                 </div>
              </div>
              <div class="col-sm-1 col-lg-1 col-xl-1">

              </div>
              </div>
              <hr v-if="this.cart_store.cart_images_image_manual.length > 0" />
              <div class="d-flex justify-content-center" v-if="this.loadding_image_manual === 'Y'" >
                <img style="align-items: center; width: 30px"
                        src="../../assets/images/running_loading.svg"
                      />
            </div>
          <paginate
                v-if="this.total_image_manual > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="3"
                :clickHandler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center pagination-sm'"
                :page-class="'page-item'"
              >
          </paginate>

          
            <div class="d-flex justify-content-center" v-if="this.cart_store.cart_images_image_manual.length <= 0 && this.isSearching === 'true'">
              images not found
            </div>
            <div id="imageShowing">
              <figure
                v-for="(src, index) in this.cart_store.cart_images_image_manual"
                :key="index"
                @click="() => showImg_image_manual(index)"
              >
                <div class="gallery event">
                  <img
                    loading="lazy"
                    :src="src.thumbnail_file_name"
                    :alt="src.original_file_name"
                  />

                  <button v-if="src.atc == 'N'"
                    class="btn" style="font-size: small;"
                    @click="
                      cart_store.add_cart_image_manual(
                        src.id,
                        src.original_file_name,
                        src.thumbnail_file_name,
                        src.preview_file_name,
                        src.photographer_id,
                        src.event_id,
                        this.currentLanguage
                      ),
                      addToCart_image_manual()
                    "
                  >
                    +{{this.currentLanguage ==='en'?"Add":"เพิ่ม"}}
                  </button>

                  <button
                    v-if="src.atc == 'Y'"
                    class="btn-delete" style="font-size: small;"
                    @click="
                      cart_store.delete_cart_image_manual(
                        src.id,
                        src.original_file_name,
                        src.thumbnail_file_name,
                        src.photographer_id
                      ),
                      addToCart_image_manual()
                    "
                  >
                    {{this.currentLanguage ==='en'?"remove":"-ลบ"}}
                  </button>
                </div>
              </figure>
            </div>
          </div>

          <p></p>
          <paginate
                v-if="this.total_image_manual > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="3"
                :clickHandler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center pagination-sm'"
                :page-class="'page-item'"
              >
          </paginate>
          <p></p>
          <vue-easy-lightbox
            pinchDisabled="true"
            scrollDisabled="true"
            :zoomDisabled="this.is_show_image_search==='Y'?true:false"
            loop="true"
            rotateDisabled="true"
            moveDisabled="true"
            :visible="visible"
            :index="index"
            :imgs="lightBoxImages_image_manual"
            @hide="handleHide"
          >
            <!-- <template v-slot:close-btn="{  }">
           
          </template> -->

            <template v-slot:toolbar="{}">
              <!-- <button class="close-btn" @click="this.addToCartlb(index)">add+</button>
              <button @click="toolbarMethods.zoomIn">zoom in</button>
            <button @click="toolbarMethods.zoomOut">zoom out</button>
            <button @click="toolbarMethods.rotateLeft">Anticlockwise rotation</button>
            <button @click="toolbarMethods.rotateRight">clockwise rotation</button> -->
            </template>
          </vue-easy-lightbox>
          
          
        </div>
        <p>&nbsp; </p>
        <!-- end image stage -->


        <!-- manual image -->
        <div class="card" v-if="this.eventDetails.is_event_manual	 === 'Y'">
          <span style="padding-top: 10px;padding-left: 20px;padding-bottom: 10px;font-size: medium;">Search photos manually</span>      
          <div >
              <div class="row">
                <div class="col-sm-1 col-lg-1 col-xl-1">
                </div>
              <div class="col-sm-10 col-lg-10 col-xl-10">
                <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="image_time" 
                            aria-label="Floating label select example">
                            <option v-for="(item, index) in this.image_times" :key="index"
                              :value="item.timeDurationKey"> {{item.timeDuration}}</option>
                      </select>
                      <label v-if="this.currentLanguage === 'en'" for="floatingSelect">Find by duration time</label>
                      <label v-if="this.currentLanguage === 'th'" for="floatingSelect">ค้นหาตามช่วงเวลาการแข่งขัน</label>
                      </div>
              </div>
              <div class="col-sm-1 col-lg-1 col-xl-1">
              </div>
              </div>
              
              <div class="row">
                <div class="col-sm-1 col-lg-1 col-xl-1">
                </div>
              <div class="col-sm-10 col-lg-10 col-xl-10">
                <div class="d-flex justify-content-center">
                  <button type="button" @click.prevent="find_image" style="cursor: pointer" class="btn btn-primary btn-lg" >
                   <vue-feather type="search" size="16" ></vue-feather>{{this.currentLanguage ==='en'?"Search":"ค้นหา"}}</button>
                   &nbsp;
                  <button style="cursor: pointer" type="reset" @click.prevent="find_image_clear" class="btn btn-secondary btn-lg" >{{this.currentLanguage ==='en'?"Cancel":"ยกเลิก"}}</button>
                 </div>
              </div>
              <div class="col-sm-1 col-lg-1 col-xl-1">

              </div>
              </div>
              <hr>
              <div class="d-flex justify-content-center" v-if="this.loadding_image_manual === 'Y'" >
                <img style="align-items: center; width: 60px"
                        src="../../assets/images/running_loading.svg"
                      />
            </div>
          <paginate
                v-if="this.total_image_manual > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="3"
                :clickHandler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center pagination-sm'"
                :page-class="'page-item'"
              >
          </paginate>

          
            <div class="d-flex justify-content-center" v-if="this.cart_store.cart_images_image_manual.length <= 0 && this.isSearching === 'true'">
              images not found
            </div>
            <div id="imageShowing">
              <figure
                v-for="(src, index) in this.cart_store.cart_images_image_manual"
                :key="index"
                @click="() => showImg_image_manual(index)"
              >
                <div class="gallery event">
                  <img
                    loading="lazy"
                    :src="src.thumbnail_file_name"
                    :alt="src.original_file_name"
                  />

                  <!-- แสดงวันที่ถ่ายภาพ -->
                  <div class="taken-date" v-if="src.taken_time">
                    {{ src.taken_time }}
                  </div>

                  <button v-if="src.atc == 'N'"
                    class="btn" style="font-size: small;"
                    @click="
                      cart_store.add_cart_image_manual(
                        src.id,
                        src.original_file_name,
                        src.thumbnail_file_name,
                        src.preview_file_name,
                        src.photographer_id,
                        src.event_id,
                        this.currentLanguage
                      ),
                      addToCart_image_manual()
                    "
                  >
                    +{{this.currentLanguage ==='en'?"Add":"เพิ่ม"}}
                  </button>

                  <button
                    v-if="src.atc == 'Y'"
                    class="btn-delete" style="font-size: small;"
                    @click="
                      cart_store.delete_cart_image_manual(
                        src.id,
                        src.original_file_name,
                        src.thumbnail_file_name,
                        src.photographer_id
                      ),
                      addToCart_image_manual()
                    "
                  >
                    {{this.currentLanguage ==='en'?"remove":"-ลบ"}}
                  </button>
                </div>
              </figure>
            </div>
          </div>

          <p></p>
          <paginate
                v-if="this.total_image_manual > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="3"
                :clickHandler="clickCallback"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center pagination-sm'"
                :page-class="'page-item'"
              >
          </paginate>
          <p></p>
          <vue-easy-lightbox
            pinchDisabled="true"
            scrollDisabled="true"
            :zoomDisabled="this.is_show_image_search==='Y'?true:false"
            loop="true"
            rotateDisabled="true"
            moveDisabled="true"
            :visible="visible"
            :index="index"
            :imgs="lightBoxImages_image_manual"
            @hide="handleHide"
          >
            <!-- <template v-slot:close-btn="{  }">
           
          </template> -->

            <template v-slot:toolbar="{}">
              <button 
                v-if="cart_store.cart_images_image_manual[index] && cart_store.cart_images_image_manual[index].atc == 'N'"
                class="lightbox-add-btn" 
                @click="addToCartFromLightbox(index)"
              >
                +{{this.currentLanguage ==='en'?"Add":"เพิ่ม"}}
              </button>
              <button 
                v-if="cart_store.cart_images_image_manual[index] && cart_store.cart_images_image_manual[index].atc == 'Y'"
                class="lightbox-remove-btn" 
                @click="removeFromCartFromLightbox(index)"
              >
                {{this.currentLanguage ==='en'?"Remove":"-ลบ"}}
              </button>
            </template>
          </vue-easy-lightbox>
          
          
        </div>
        <!-- end manual image -->


      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";

import "@sweetalert2/theme-bootstrap-4/bootstrap-4.scss";
import { ref } from "vue";
import router from "../../router";
import { useCartStoreManual } from "../../store/modules/cart_manual";
import axios from "axios";
import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
const isBtnaddToCartClick = ref(0);
const isBtnshowImgClick = ref(0);

const image_manual_isBtnaddToCartClick = ref(0);
const image_manual_isBtnshowImgClick = ref(0);
import VuejsPaginateNext from "../../components/Paginate.vue";
import ManualSearchNote from "../../components/ManualSearchNote.vue";

export default {
  components: {
    paginate: VuejsPaginateNext,
    ManualSearchNote,
  },
  setup() {
    const siteData = reactive({
      title: process.env.VUE_APP_SYSTEM_NAME,
      description: process.env.VUE_APP_SYSTEM_NAME,
      keywords: process.env.VUE_APP_SYSTEM_NAME,
      image:  process.env.VUE_APP_WEBSITE_IMAGE,
    })

    useHead({
      // Can be static or computed this.eventDetails.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        ],
     
    })

    
    const cart_store = useCartStoreManual();
    cart_store.loadFromLocalStorage();
    return { cart_store ,siteData};
  },

  data() {
    return {
      fbName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME || '',
      fbUrl: process.env.VUE_APP_SYSTEM_FACEBOOK_URL || '',
      isSearching: "false",
      isFoundImage: "true",
      eventDetails: {},
      eventPackage: {},
      lightBoxImages: [],
      visible: false,
      index: "",
      cart: [],
      imgs_avg_price: 0,
      images_download_all: [],

      lightBoxImages_hl: [],
      index_hl: "",
      visible_hl: false,
      loadding_highlight: "",
      data_highlight: [],
      is_show_image_search: "" ,
      currentLanguage: 'en',

      lightBoxImages_image_manual: [],
      index_image_manual: "",
      visible_image_manual: false,
      loadding_image_manual: "N",
      data_image_manual: [],
      page: 1,
      init_page_size: 200,
      page_tab: 0,
      total_image_manual: 0,
      event_stages: "0",

      image_times: [],
      image_time: "0",
    
    };

    
  },
  
  async created(){
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
  },
  async mounted() {
    let _data = await this.getEventDetail(this.$route.params.event_id);
    this.siteData.image = _data.coverurl ;
    this.siteData.title = _data.title +' '+this.siteData.title ;
    this.siteData.description = _data.title +' วันที่ '+_data.event_date_text+' ณ.'+_data.province+' '+this.siteData.description ;
    
    if (this.lightBoxImages.length <= 0) {
      this.lightBoxImages.length = [];
      this.images_download_all = [];
      
      if(this.cart_store.cart_images.length > 0 ){
        this.is_show_image_search = "Y"
        this.cart_store.cart_images.forEach((item) => {
        
        this.lightBoxImages.push({
          src: item.preview_file_name,
          title:
            "IMAGEID: " +
                      item.id +
                      (item.taken_time ? "\ntaken: " + item.taken_time : "")
                      +" P:"+item.photographer_id ,
        });
        this.images_download_all.push(item.preview_file_name);
      });
      this.imgs_avg_price  = (this.eventDetails.mhao_price/this.cart_store.cart_images.length).toFixed(2)
      }

    }

    this.highlight();
    // if(_data.is_event_manual	=== 'Y'){
    //   this.image_manual(_data)
    //   this.image_manual_count(_data)
    // }
    
  },
  methods: {
    formatTakenDate(takenDate) {
      if (!takenDate) return '';
      
      try {
        const date = new Date(takenDate);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${hours}:${minutes}`;
      } catch (error) {
        return '';
      }
    },
    async find_image(){
      //console.log(JSON.stringify(this.eventDetails))
      this.page = 1;
      this.image_manual(this.eventDetails)
      this.image_manual_count(this.eventDetails)
    },
    async find_image_clear(){
      
      this.event_stages = "0"
      this.image_time = "0"
      this.lightBoxImages_image_manual = []
      this.cart_store.cart_images_image_manual = [];
      this.total_image_manual = 0;
      this.data_image_manual = []


      this.image_manual(this.eventDetails)
      this.image_manual_count(this.eventDetails)
    },
    addToCart_image_manual() {
      image_manual_isBtnaddToCartClick.value = 1;
    },
    async image_manual_count(_data) {
      console.log("this.event_stages:"+this.event_stages)
      console.log("this.this.image_time:"+this.image_time)

      if(this.event_stages == 0 && this.image_time == 0){

      }else{
        let data = {
          event_id: _data.event_id,
          event_stages_id: this.event_stages,
          event_image_duration: this.image_time
        };
        //console.log("data"+JSON.stringify(data))
        const pagination_count = await axios.post(
          "/v1/imagestage/pagination-count",
          data
        );

        this.total_image_manual = pagination_count.data.body[0].image_count;
        this.page_tab = Math.round(
          this.total_image_manual / this.init_page_size + 0.5
        );
      }
        //console.log("this.total_image_manual"+this.total_image_manual+"|"+this.page_tab)
    },
    async clickCallback(pageNum) {
      let data = {
        page: pageNum,
        page_size: this.init_page_size,
        total_image_manual: this.total_image_manual,
        page_tab: this.page_tab,
        event_key: this.$route.params.event_id,
        event_id: this.eventDetails.event_id,
        event_stages_id: this.event_stages,
        event_image_duration: this.image_time
      };
      const response = await axios.post("/v1/imagestage/pagination", data);

      this.cart_store.cart_images_image_manual = response.data.body;

      this.lightBoxImages_image_manual = []
      this.cart_store.cart_images_image_manual.forEach((item) => {
          this.lightBoxImages_image_manual.push({
                    src: item.preview_file_name,
                    title:
                      "IMAGEID: " +
                      item.id +
                      (item.taken_time ? "\ntaken: " + item.taken_time : "")
                      +" P:"+item.photographer_id ,
                  });
      });


    },
    showImg_image_manual(index) {
      image_manual_isBtnshowImgClick.value = 1;

      if (image_manual_isBtnaddToCartClick.value === 0) {
        this.index = index;
        this.visible = true;
      }
      image_manual_isBtnaddToCartClick.value = 0;
      image_manual_isBtnshowImgClick.value = 0;
    },
    async image_manual(_data) {
      if(this.event_stages == 0 && this.image_time == 0){
        
      }else{
        this.loadding_image_manual = "Y";
      let data = {
        page: 1,
        page_size: this.init_page_size,
        event_key: this.$route.params.event_id,
        event_id: _data.event_id,
        event_stages_id: this.event_stages,
        event_image_duration: this.image_time
        
      };
      const response = await axios.post("/v1/imagestage/pagination", data);
      if (response.data.status === "success") {
        this.cart_store.cart_images_image_manual = response.data.body;

        this.lightBoxImages_image_manual = []
        this.cart_store.cart_images_image_manual.forEach((item) => {
          this.lightBoxImages_image_manual.push({
                    src: item.preview_file_name,
                    title:
                      "IMAGEID: " +
                      item.id +
                      (item.taken_time ? "\ntaken: " + item.taken_time : "")
                      +" P:"+item.photographer_id ,
                  });
        
      });

        this.loadding_image_manual = "N";
      } else {
        this.loadding_image_manual = "N";
      }
      }
      
    },
    async highlight() {
      this.loadding_highlight = "Y";
      let data = {
        event_key: this.$route.params.event_id,
      };
      const response = await axios.post("/v1/facesearch/highlight", data);

      if (response.data.status === "success") {
        this.data_highlight = response.data.body;

        this.data_highlight.forEach((item) => {
          this.lightBoxImages_hl.push({
            src: item.preview_file_name,
            title: 'ตัวอย่างภาพความประทับใจ',
          });
        
      });

        this.loadding_highlight = "N";
      } else {
        this.loadding_highlight = "N";
        //alert("Load order พบข้อผิดพลาด!");
      }
    },
    async sleep_only() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 200);
      });
    },
    async load_images() {
      let result = await Swal.fire({
        icon: "info",
        title:
          "กรุณาเปิดอนุญาตป๊อปอัป เมื่อเริ่มดาวน์โหลด,  ระบบจะดาวน์โหลดรูปทั้งหมด อัตโนมัติ ",
        html: "<b><u>แนะนำใช้งานผ่านคอมพิวเตอร์หรือระบบแอนดรอยด์</u></b>,<br> บนระบบ ios ระบบจะเปิดแทบเท่ากับจำนวนรูปเพื่อให้กดค้างเพื่อบันทึก <br>คุณต้องการดาวน์โหลดรูปทั้งหมดใช่หรือไม่?",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#7991a8",
        confirmButtonText: "เริ่มดาวน์โหลด",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          let count = 0;
          // console.log("images_dl.length"+this.images_download_all.length)
          while (count < this.images_download_all.length) {
            window.open(
              this.images_download_all[count] + "?openExternalBrowser=1",
              "_blank"
            );
            this.sleep_only();
            count++;
          }
        } else {
          return false;
        }
      });
    },
    async download(url) {
      window.open(url, "_blank");
    },
    async getEventImageTime(event_key) {
      const res = await axios.get("/v1/events/" + event_key+"/image-time");
      if (res.data.status === "success") {
        this.image_times = res.data.body;
      }
    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      //console.log("res.data",JSON.stringify(res.data))
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;

        this.getEventImageTime(this.$route.params.event_id)

        let consent_check = localStorage.getItem(
          "consent_" + this.$route.params.event_id
        );
        if (consent_check !== "true") {
          if(this.currentLanguage === 'th'){
            let result = await this.cart_store.alert_policy_consent();
            if (result) {
              localStorage.setItem(
                "consent_" + this.$route.params.event_id,
                "true"
              );

              
            } else {
              router.push({ path: "/" });
            }
          }else{
            let result = await this.cart_store.alert_policy_consent_en();
            if (result) {
              localStorage.setItem(
                "consent_" + this.$route.params.event_id,
                "true"
              );
            } else {
              router.push({ path: "/" });
            }
          }
          

        }
        return res.data;
      } else {
        //alert("พบข้อผิดพลาด! ไม่พบ url ของกิจกรรม");
        router.push({ path: "/404" });
      }
    },
    addToCart() {
      isBtnaddToCartClick.value = 1;
    },
    
    addAllImageToCart() {
      //router.push({ path: "cart" });
    },
    showImg(index) {
      isBtnshowImgClick.value = 1;

      if (isBtnaddToCartClick.value === 0) {
        this.index = index;
        this.visible = true;
      }
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    handleHide() {
      this.visible = false;
      isBtnaddToCartClick.value = 0;
      isBtnshowImgClick.value = 0;
    },
    
    addToCartFromLightbox(index) {
      const item = this.cart_store.cart_images_image_manual[index];
      if (item && item.atc === 'N') {
        this.cart_store.add_cart_image_manual(
          item.id,
          item.original_file_name,
          item.thumbnail_file_name,
          item.preview_file_name,
          item.photographer_id,
          item.event_id,
          this.currentLanguage
        );
        this.addToCart_image_manual();
      }
    },
    removeFromCartFromLightbox(index) {
      const item = this.cart_store.cart_images_image_manual[index];
      if (item && item.atc === 'Y') {
        this.cart_store.delete_cart_image_manual(
          item.id,
          item.original_file_name,
          item.thumbnail_file_name,
          item.photographer_id
        );
        this.addToCart_image_manual();
      }
    },
    faceSearch() {
      if(this.eventDetails.is_mhao === 'Y'){
        
        if(this.cart_store.cart.length > 0){
          if(confirm(this.currentLanguage==='en'?"You have photos in your shopping cart. If you search again The pictures in the basket will be Automatically deleted Do you want to continue the transaction?":"ท่านมีรูปที่ทำรายการค้างอยู่ในตะกร้า ถ้าหากค้นหาใหม่อีกครั้ง รูปที่อยู่ในตะกร้าจะถูก ลบออกโดยอัตโนมัติ  ต้องการทำรายการต่อใช่หรือไม่?")){
            this.cart_store.clear_cart(this.eventDetails.is_mhao)
            this.faceSearch_action();
          }else{
            document.getElementById("fileInput").value = null;
          }

        }else{ 
          this.faceSearch_action();
        }

      }else{
        this.faceSearch_action();
      }

        

      
    },
    faceSearch_action(){
      if (document.getElementById("fileInput").value != "") {
        var file_size = fileInput.files[0].size / 1000000;
        //console.log("fileInput size mb:" + file_size);
        //console.log("fileInput size type:" + fileInput.files[0].type);//image/jpeg  image/png
        if(fileInput.files[0].type === 'image/jpeg' || fileInput.files[0].type === 'image/png'){
          this.lightBoxImages = [];
        this.isSearching = "true";
        this.is_show_image_search = "Y"
        this.isFoundImage = "true";
        this.cart_store.clear_cart_images();
        this.cart_store.clear_cart_latest();
        this.imgs_avg_price = 0;
        document.getElementById("fileInput").disabled = true;
        var formdata = new FormData();
        //var requestOptions = {
        //  method: "POST",
        //  body: formdata,
        //  redirect: "follow",
        //};
        formdata.append("file", fileInput.files[0], fileInput.files[0].name);
        formdata.append("event_id", this.eventDetails.event_id);
        formdata.append("event_key", this.$route.params.event_id);
        formdata.append("face_threshold", this.eventDetails.face_threshold);
        formdata.append("mhao_price", this.eventDetails.mhao_price);
        formdata.append("max_face_search", this.eventDetails.max_face_search);
        //console.log(this.eventDetails.mhao_price)
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          process.env.VUE_APP_RUNNING_API + "/v1/facesearch",
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            result = JSON.parse(result);

            //console.log("result.status " + JSON.stringify(result));
            if (result.status === "success") {
              if (result.image_length > 0) {
                this.isFoundImage = "true";
                this.cart_store.cart_images = result.images;

                if(this.eventDetails.is_mhao === 'Y'){
                  this.cart_store.cart_latest = result.images;
                }
                localStorage.setItem('cart_latest', JSON.stringify(this.cart_store.cart_latest))

                this.imgs_avg_price = result.avg_price;
                this.cart_store.cart_images.forEach((item) => {
                  this.lightBoxImages.push({
                    src: item.preview_file_name,
                    title:
                      "IMAGEID: " +
                      item.id +
                      (item.taken_time ? "\ntaken: " + item.taken_time : "")
                      +" P:"+item.photographer_id ,
                  });
                  this.images_download_all.push(item.preview_file_name);
                });
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
              } else {
                this.isSearching = "false";
                document.getElementById("fileInput").disabled = false;
                //alert("ไม่พบรรูปที่ตรงกัน");
                this.isFoundImage = "false";
              }
            } else {
              this.isSearching = "false";
              this.isFoundImage = "false";
              document.getElementById("fileInput").disabled = false;
              this.cart_store.alert_commomd_message_info(
                "พบข้อผิดพลาดจากการค้นหา กรุณาลองอีกครั้ง"
              );
            }
            document.getElementById("fileInput").value = null;
          })
          .catch((error) => console.log("error", error));
          
        }else{
          this.cart_store.alert_commomd_message_info("กรุณาใช้ไฟล์ jpg หรือ png เพื่อค้นหาเท่านั้น");
        }
        
      
        
      }

    }
    ,
    addToCartlb(_image_id){
      //console.log("_image_id:"+_image_id)
    }
  },
};
</script>

<style scoped>

/* Paginate styles - Gray theme */
:deep(.pagination) {
  --bs-pagination-color: #6c757d;
  --bs-pagination-bg: #f8f9fa;
  --bs-pagination-border-color: #dee2e6;
  --bs-pagination-hover-color: #495057;
  --bs-pagination-hover-bg: #e9ecef;
  --bs-pagination-hover-border-color: #dee2e6;
  --bs-pagination-focus-color: #495057;
  --bs-pagination-focus-bg: #e9ecef;
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(108, 117, 125, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #6c757d;
  --bs-pagination-active-border-color: #6c757d;
  --bs-pagination-disabled-color: #adb5bd;
  --bs-pagination-disabled-bg: #f8f9fa;
  --bs-pagination-disabled-border-color: #dee2e6;
}

/* Alternative method using direct CSS classes */
:deep(.pagination .page-item .page-link) {
  color: #6c757d;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

:deep(.pagination .page-item:hover .page-link) {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

:deep(.pagination .page-item.active .page-link) {
  color: #fff;
  background-color: #1e1e1f;
  border-color: #6c757d;
}

:deep(.pagination .page-item.disabled .page-link) {
  color: #adb5bd;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

input[type="checkbox"] {
  display: none;
}

div.gallery:hover {
  cursor: pointer;
  opacity: 0.9;
}

div.gallery_hl:hover {
  cursor: pointer;
  opacity: 0.7;
}

@media screen and (min-width: 851px) and (max-width: 9000px) {
  div.gallery {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gallery img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }

  div.gallery_hl {
    margin: 2px;
    float: left;
    min-height: auto;
    max-height: 229px;
    min-width: auto;
    max-width: 346px;
  }

  div.gallery_hl img {
    position: relative;
    min-height: 100%;
    max-height: 231.66px;
    min-width: 100%;
    padding: 0.5px;
    max-width: 346px;
  }
}

@media screen and (min-width: 451px) and (max-width: 850px) {
  div.gallery {
    margin: 1px;
    float: left;
    min-height: auto;
    max-height: 193px;
    min-width: auto;
    max-width: 290px;
  }

  div.gallery img {
    position: relative;
    min-height: 100%;
    max-height: 194.66px;
    min-width: 100%;
    padding: 1px;
    max-width: 290px;
  }

  div.gallery_hl {
    margin: 2px;
    float: left;
    min-height: auto;
    max-height: 225px;
    min-width: auto;
    max-width: 340px;
  }

  div.gallery_hl img {
    position: relative;
    min-height: 100%;
    max-height: 225.96px;
    min-width: 100%;
    padding: 0.5px;
    max-width: 340px;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  div.gallery {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 2px;
    border: 1px solid #ccc;
  }

  div.gallery img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }

  div.gallery_hl {
    width: 49%;
    float: left;
    margin: 1px;
    padding: 2px;
    border: 1px solid #ccc;
  }

  div.gallery_hl img {
    min-height: 100%;
    max-height: 100%;
    min-width: 100%;
    max-width: 100%;
    padding: 2px;
  }
}

.drop-container {
  position: relative;
  display: flex;
  gap: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 150px;
  width: 100%;
  padding: 10px;
  border-radius: 3px;
  border: 1px dashed #b9b9b9;
  cursor: pointer;
  transition: background 0.2s ease-in-out, border 0.2s ease-in-out;
}
.drop-container {
  background: #c9c9c946;
}
.drop-container:hover {
  background: #979696ad;
}
/* 
.drop-container:hover .drop-title {
  color: #222;
} */

.drop-title {
  color: #444;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  transition: color 0.2s ease-in-out;
}

input[type="file"] {
  display: none;
}

.event {
  position: relative;
  width: auto;
  height: auto;
}

.event img {
  height: auto;
  width: auto;
}

.event .btn {
  position: absolute;
  top: 86%;
  left: 82%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #0486d6;
  color: white;
  padding: 3px 3px;
  border: 1px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}
.event .btn-free-download {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #0486d6;
  color: white;
  padding: 3px 3px;
  border: 1px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .btn-delete {
  position: absolute;
  top: 86%;
  left: 82%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 5px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .btn-delete-go-to-cart {
  position: absolute;
  top: 10%;
  left: 80%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #ff1c1c;
  color: white;
  padding: 3px 3px;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.event .taken-date {
  position: absolute;
  top: 90%;
  left: 38%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2px 3px;
  border: none;
  border-radius: 3px;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  white-space: nowrap;
  z-index: 1;
}

.event_hl {
  position: relative;
  width: auto;
  height: auto;
}

.event_hl img {
  height: auto;
  width: auto;
}

/* Lightbox buttons */
.lightbox-add-btn {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background-color: #0486d6;
  color: white;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.lightbox-add-btn:hover {
  background-color: #0367a6;
}

.lightbox-remove-btn {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background-color: #ff1c1c;
  color: white;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.lightbox-remove-btn:hover {
  background-color: #d11515;
}

/*
.event .btn:hover {
  background-color: black;
}
.event .btn-delete:hover {
  background-color: black;
}
*/
</style>
    
